<template>
    <div class="page-store xc-page xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/store'">系统设置</router-link>
                <a>门店管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form" name="search" @submit.prevent="mix_search">
                            <div class="xc-form-inline">
                                <xc-form-item label="状态：" labelWidth="0">
                                    <select name="status" class="xc-select" v-model="mix_query.status">
                                        <option value="">不限</option>
                                        <option value="0">启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item label="门店名称：" labelWidth="0">
                                    <input type="text" name="storeName" class="xc-input" placeholder="请输入门店名称" v-model="mix_query.storeName">
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button type="submit" class="xc-btn xc-btn-primary">查询</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click="add">添加</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click="importDevice">导入设备</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click="exportStore">导出</button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>门店名称</th>
                                    <th>导入设备</th>
                                    <th>已激活设备</th>
                                    <th>门店序列号</th>
                                    <th>电话</th>
                                    <!-- <th>传真</th> -->
                                    <th>状态</th>
                                    <th>操作人</th>
                                    <th>覆盖人数</th>
                                    <th>最后操作时间</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.storeId}}</td>
                                        <td>{{item.storeName}}</td>
                                        <td>{{item.uploadExcelDeviceNum}}</td>
                                        <td>{{item.registDeviceNum}}</td>
                                        <td>{{item.serialNum}}</td>
                                        <td>{{item.cellPhone}}</td>
                                        <!-- <td>{{item.fax}}</td> -->
                                        <td>{{item.status | filter0}}</td>
                                        <td>{{operator(item)}}</td>
                                        <td>{{item.coveredPopulation}}</td>
                                        <td>{{lastTime(item)|moment}}</td>
                                        <td>
                                            <xc-btn-select title="管理">
                                                <template v-if="groups(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="mix_pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加-->
            <div class="xc-modal xc-modal-dialog" v-if="modalName=='add'">
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">添加</div>
                            <div
                                class="xc-modal-close"
                                @click="addClose"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form store"
                                name="add"
                                data-vv-scope="add"
                            >
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="门店名称:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="storeName"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="门店名称"
                                            placeholder="请输入门店名称"
                                            v-model="current.storeName"
                                            :class="{'xc-input-error':errors.first('storeName','add')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("storeName","add")}}
                                        </div>
                                    </xc-form-item>

                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="门店负责人:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="storeFunctionary"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="门店负责人"
                                            placeholder="请输入门店负责人"
                                            v-model="current.storeFunctionary"
                                            :class="{'xc-input-error':errors.first('storeFunctionary','add')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("storeFunctionary","add")}}
                                        </div>
                                    </xc-form-item>
                                    <xc-form-item label="手机号码:" :error="errors.first('cellPhone','add')">
                                        <input
                                            type="tel"
                                            name="cellPhone"
                                            v-validate="'mobile'"
                                            data-vv-as="手机号码"
                                            v-model="current.cellPhone"
                                            class="xc-input"
                                            placeholder="请输入手机号码"
                                            maxlength="11"
                                        >

                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="固定电话:">
                                        <input
                                            type="tel"
                                            name="settledPhone"
                                            v-model="current.settledPhone"
                                            class="xc-input"
                                            placeholder="请输入固定电话"
                                            maxlength="11"
                                        >
                                    </xc-form-item>
                                    <xc-form-item label="覆盖人数:" required :error="errors.first('coveredPopulation','add')">
                                        <input
                                            type="text"
                                            name="coveredPopulation"
                                            v-validate="'required'"
                                            data-vv-as="覆盖人数"
                                            v-model="current.coveredPopulation"
                                            @input="current.coveredPopulation=current.coveredPopulation.replace(/\D/g,'')"
                                            class="xc-input"
                                            placeholder="请输入覆盖人数"
                                            :class="{'xc-input-error':errors.first('coveredPopulation','add')}"
                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline address">
                                    <xc-form-item
                                        label="详细地址："
                                        required=""
                                    >
                                        <div class="address-item">
                                            <input
                                                type="text"
                                                name="province"
                                                v-model="current.province"
                                                class="xc-input xc-input-disabled xc-select-area province"
                                                disabled
                                                placeholder="省"
                                                data-vv-as="省份"
                                                v-validate="'required'"
                                                :class="{'xc-input-error':errors.first('province','add')}"
                                            />
                                            <div class="xc-form-item-error-tips">
                                                {{errors.first('province','add')}}
                                            </div>
                                        </div>
                                        <div class="address-item">
                                            <input
                                                type="text"
                                                name="city"
                                                v-model="current.city"
                                                class="xc-input xc-input-disabled xc-select-area city"
                                                disabled
                                                placeholder="市"
                                                data-vv-as="城市"
                                                v-validate="'required'"
                                                :class="{'xc-input-error':errors.first('city','add')}"
                                            />
                                            <div class="xc-form-item-error-tips">
                                                {{errors.first('city','add')}}
                                            </div>
                                        </div>
                                        <div class="address-item">
                                            <input
                                                type="text"
                                                name="area"
                                                v-model="current.area"
                                                class="xc-input xc-input-disabled xc-select-area area"
                                                disabled
                                                placeholder="区"
                                                data-vv-as="行政区"
                                                v-validate="'required'"
                                                :class="{'xc-input-error':errors.first('area','add')}"
                                            />
                                            <div class="xc-form-item-error-tips">
                                                {{errors.first('area','add')}}
                                            </div>
                                        </div>
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline location">
                                    <xc-form-item>
                                        <input
                                            type="hidden"
                                            name="longitude"
                                            v-model="current.longitude"
                                            class="longitude"
                                        />
                                        <input
                                            type="hidden"
                                            name="latitude"
                                            v-model="current.latitude"
                                            class="latitude"
                                        />
                                        <input
                                            type="text"
                                            name="storeAdd"
                                            v-model="current.storeAdd"
                                            class="xc-input  storeAdd"
                                            placeholder="请输入详细地址"
                                        >
                                        <img
                                            class="locationIcon"
                                            @click="addStreet"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAaCAMAAADorg53AAAAclBMVEUAAADQ1eHP1uDQ1eHR2ODY2OvQ1eDT2eTP1eDu8vnP1eBXgt/n6/NbheBnjuKku+zc4OqQrenL2PN2meXi6vfY4vXP2/TB0fG3yfCUsOqLqehji+Hd5vbV4PW9zvGswe6HpuhwlOPq7/izxu+dtuuOq+j6g/kYAAAACXRSTlMA8+CBQg3P/tCSivUMAAAA+klEQVQoz43T6a6CQAwF4BkQtBzLDrLIpt73f8ULg8QhsYbza6b5Ugi0ao7n+jr4Gu27njI5OfGVhFxj52TM2RCRnWflOZuRlOMpN7Yr99fEPL3udi121cVu9GSY8NNu5SttXQegSR+PtAEGq6xV8LkUjGo9VeDiUw9sVCMhisIwIkpQCyhERxHmRNQhFBCwwNttAYCAWuQbytEKKEO5Pa5EJqJ0e/FeRBH+tuOIQUAFkL//DjgXEI1I1kOChiTUMer1q3IhIqqAZOmDinZIk52e0YzgflfUyt/PXNoCbbqfOt8MnZ1yysp9JXYPje+RRTi4UmY5L7+X8x/cgCVNeQ3wMQAAAABJRU5ErkJggg=="
                                        />
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="门店logo：">
                                        <!--<img class="logo" src="faf"/>-->
                                        <xc-upload
                                            :fileList.sync="images"
                                            :uploadSuccess="uploadSuccess"
                                            type="3"
                                            accept="image/*"
                                            :url="uploadUrl"
                                        />
                                        <input
                                            type="hidden"
                                            name="storePhoto"
                                            v-model="current.storePhoto"
                                        />
                                    </xc-form-item>
                                </div>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="addClose"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">编辑</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form store"
                                name="edit"
                                data-vv-scope="edit"
                            >
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="门店名称:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="storeName"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="门店名称"
                                            placeholder="请输入门店名称"
                                            v-model="current.storeName"
                                            :class="{'xc-input-error':errors.first('storeName','edit')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("storeName","edit")}}
                                        </div>
                                    </xc-form-item>

                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="门店负责人:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="storeFunctionary"
                                            v-model="current.storeFunctionary"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="门店负责人"
                                            placeholder="请输入门店负责人"
                                            :class="{'xc-input-error':errors.first('storeFunctionary','edit')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("storeFunctionary","edit")}}
                                        </div>
                                    </xc-form-item>
                                    <xc-form-item label="手机号码:" :error="errors.first('cellPhone','edit')">
                                        <input
                                            type="tel"
                                            name="cellPhone"
                                            v-validate="'mobile'"
                                            data-vv-as="手机号码"
                                            v-model="current.cellPhone"
                                            class="xc-input"
                                            placeholder="请输入手机号码"
                                            maxlength="11"

                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="固定电话:">
                                        <input
                                            type="tel"
                                            name="settledPhone"
                                            v-model="current.settledPhone"
                                            class="xc-input"
                                            placeholder="请输入固定电话"
                                            maxlength="11"
                                        >
                                    </xc-form-item>
                                    <xc-form-item label="覆盖人数:" required :error="errors.first('coveredPopulation','edit')">
                                        <input
                                            type="text"
                                            name="coveredPopulation"
                                            v-validate="'required'"
                                            data-vv-as="覆盖人数"
                                            v-model="current.coveredPopulation"
                                            class="xc-input"
                                            @input="current.coveredPopulation=current.coveredPopulation.replace(/\D/g,'')"
                                            placeholder="请输入覆盖人数"
                                            :class="{'xc-input-error':errors.first('coveredPopulation','edit')}"
                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline address">
                                    <xc-form-item
                                        label="详细地址："
                                        required
                                    >
                                        <div class="address-item">
                                            <input
                                                type="text"
                                                name="province"
                                                v-model="current.province"
                                                class="xc-input xc-input-disabled xc-select-area province"
                                                disabled
                                                placeholder="省"
                                                data-vv-as="省份"
                                                v-validate="'required'"
                                                :class="{'xc-input-error':errors.first('province','edit')}"
                                            />
                                            <div class="xc-form-item-error-tips">
                                                {{errors.first('province','edit')}}
                                            </div>
                                        </div>
                                        <div class="address-item">
                                            <input
                                                type="text"
                                                name="city"
                                                v-model="current.city"
                                                class="xc-input xc-input-disabled xc-select-area city"
                                                disabled
                                                placeholder="市"
                                                data-vv-as="城市"
                                                v-validate="'required'"
                                                :class="{'xc-input-error':errors.first('city','edit')}"
                                            />
                                            <div class="xc-form-item-error-tips">
                                                {{errors.first('city','edit')}}
                                            </div>
                                        </div>
                                        <div class="address-item">
                                            <input
                                                type="text"
                                                name="area"
                                                v-model="current.area"
                                                class="xc-input xc-input-disabled xc-select-area area"
                                                disabled
                                                placeholder="区"
                                                data-vv-as="行政区"
                                                v-validate="'required'"
                                                :class="{'xc-input-error':errors.first('area','edit')}"
                                            />
                                            <div class="xc-form-item-error-tips">
                                                {{errors.first('area','edit')}}
                                            </div>
                                        </div>
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline location">
                                    <xc-form-item>
                                        <input
                                            type="hidden"
                                            name="longitude"
                                            v-model="current.longitude"
                                            class="longitude"
                                        />
                                        <input
                                            type="hidden"
                                            name="latitude"
                                            v-model="current.latitude"
                                            class="latitude"
                                        />
                                        <input
                                            type="text"
                                            name="storeAdd"
                                            v-model="current.storeAdd"
                                            class="xc-input  storeAdd"
                                            placeholder="请输入详细地址"
                                        >
                                        <img
                                            class="locationIcon"
                                            @click="addStreet"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAaCAMAAADorg53AAAAclBMVEUAAADQ1eHP1uDQ1eHR2ODY2OvQ1eDT2eTP1eDu8vnP1eBXgt/n6/NbheBnjuKku+zc4OqQrenL2PN2meXi6vfY4vXP2/TB0fG3yfCUsOqLqehji+Hd5vbV4PW9zvGswe6HpuhwlOPq7/izxu+dtuuOq+j6g/kYAAAACXRSTlMA8+CBQg3P/tCSivUMAAAA+klEQVQoz43T6a6CQAwF4BkQtBzLDrLIpt73f8ULg8QhsYbza6b5Ugi0ao7n+jr4Gu27njI5OfGVhFxj52TM2RCRnWflOZuRlOMpN7Yr99fEPL3udi121cVu9GSY8NNu5SttXQegSR+PtAEGq6xV8LkUjGo9VeDiUw9sVCMhisIwIkpQCyhERxHmRNQhFBCwwNttAYCAWuQbytEKKEO5Pa5EJqJ0e/FeRBH+tuOIQUAFkL//DjgXEI1I1kOChiTUMer1q3IhIqqAZOmDinZIk52e0YzgflfUyt/PXNoCbbqfOt8MnZ1yysp9JXYPje+RRTi4UmY5L7+X8x/cgCVNeQ3wMQAAAABJRU5ErkJggg=="
                                        />
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="门店logo：">
                                        <xc-upload
                                            :fileList.sync="images"
                                            :uploadSuccess="uploadSuccess"
                                            type="3"
                                            accept="image/*"
                                            :url="uploadUrl"
                                        />
                                        <input
                                            type="hidden"
                                            name="storePhoto"
                                            v-model="current.storePhoto"
                                        />
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="创建时间：">
                                        <input
                                            type="text"
                                            name="createTime"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            :value="$dateFormat(current.createTime)"
                                        >
                                    </xc-form-item>
                                    <xc-form-item label="上次修改时间：">
                                        <input
                                            type="text"
                                            name="updateTime"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            :value="$dateFormat(current.updateTime)"
                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="最近操作人：">
                                        <input
                                            type="text"
                                            name="updatePersonName"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            :value="operator(current)"
                                        >
                                    </xc-form-item>
                                </div>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="editSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--禁用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">禁用</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定禁用该门店？禁用后该门店下所有用户账号不能使用
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="disabledSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--启用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">启用</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定启用该门店？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="activeSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该门店？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import myLayerImport from "@/libs/myLayer"
import "@/libs/vee-validate";
import dateFormat from "@/utils/date-format"
import formFormat from "@/utils/form-format"
import { getStore, getDepartment, addStore, editStore, updateStatus, deleteStore,exportStoreExcel} from "@/api/store"
// import exportStoreExcel from "@/api/exportStore"
import "@/libs/font-awesome"

export default {
    name: 'storeList',
    mixins: [listMixin],
    data() {
        return {
            adminPath: this.$config.adminPath,
            images: [],
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'storeCode',

            list: [],

            // 默认查询参数
            mix_query: {
                status: "",
                storeName: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0,
                },
                {
                    name: "导入设备",
                    id: 2,
                },
                {
                    name: "禁用",
                    id: 3,
                },
                {
                    name: "启用",
                    id: 4,
                },
                {
                    name: "删除",
                    id: 5,
                },
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,   //当前表行
            uploadUrl: '/uploadfile',
        }
    },
    filters:{
        filter0(value){
            return value==0?"启用":"禁用"
        }
    },
    computed: {
    },
    methods: {
        //获取操作人
        operator(item){
            return item.updatePersonName?item.updatePersonName:item.createPersonName;
        },
        //获取最后操作时间
        lastTime(item){
            return item.updateTime?item.updateTime:item.createTime;
        },
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            console.log('search', search);

            getStore(search).then(function (success) {
                //添加mix_checkbox属性
                _this.list = _this.mix_format(success.data.list);
                _this.mix_total = success.data.total;
                _this.mix_page = success.data.pageNum;
                _this.mix_pageSize = success.data.pageSize;
            }).catch(function (error) {
                _this.$message.error("出了一点问题")
            })
        },
        //上传完成
        uploadSuccess: function (res) {
            /*console.log(11111111,res);
            this.current.storePhoto = res.data[0].url;*/
        },
        //添加门店
        add: function () {
            this.modalName = "add";
            this.images = [];
            this.current = {
                storeName: "",
                storeFunctionary: "",
                cellPhone: "",
                settledPhone: "",
                fax: "",
                province: "",
                city: "",
                area: "",
                storeAdd: "",
                longitude: "",
                latitude: "",
                storePhoto: "",
                coveredPopulation: ""
            };
        },
        //导入设备
        importDevice: function () {
            // this.$router.push(this.adminPath + "/system/device/import")
            // this.layer({
            //     area: ["90%", "90vh"],
            //     content: this.adminPath + "/system/device/import"
            // });
            window.store=this;
            layer.openSubpage(this.adminPath + "/system/device/import");
        },
        //导出门店
        exportStore(){
            var obj={
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };
            exportStoreExcel({
                responseType: 'blob',
                params:obj
            }).then(v => {
                this.$message.success("导出门店成功");
                let url = window.URL.createObjectURL(new Blob([v]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '门店列表.xlsx')

                document.body.appendChild(link)
                link.click()
            }).catch(res => {
                console.log(res)
            })
        },
        // 操作单条数据
        action(...args) {
            console.log(args);
            const [action, item, index] = args;
            const e = args[args.length - 1];
            this.current = { ...item };
            switch (action.id) {
                case 0:
                    this.modalName = "edit";
                    this.images = [];
                    if (this.current.storePhoto) {
                        this.images[0] = {
                            file: this.current.storePhoto,
                            url:this.current.storePhoto
                        };
                    }
                    break;
                case 2:
                    //导入设备
                    window.store=this;
                    layer.openSubpage(this.adminPath + "/system/device/import?storeId=" + this.current.storeId + "&channel=1");
                    break;
                case 3:
                    this.modalName = "disabled";

                    break;
                case 4:
                    this.modalName = "active";
                    break;
                case 5:
                    this.modalName = "delete";

                    break;
                default:
                    break;
            }
        },
        //判断分组内容
        groups: function (item) {
            var arr = this.group.slice(0);
            if (item.status == 0) {
                //0表示正常,1表示冻结
                arr.splice(3, 1);
            } else {
                arr.splice(2, 1)
            }
            return arr;
        },
        //选择部门
        selectDepartment: function () {
            myLayer.open({
                type: 2,
                title: false,
                closeBtn: 0,
                content: this.adminPath + "/system/department/select",
                success: function (layero, index) {
                }
            })
        },
        //打开地图
        addStreet: function () {
            this.$nextTick(function () {
                myLayer.open({
                    type: 2,
                    title: false,
                    closeBtn: 0,
                    content: this.adminPath + "/system/map",
                    success: function (layero, index) {
                        console.log("打开子页面");
                    },
                })
            })
        },
        //    添加确定
        addSubmit: function () {
            var _this = this;
            // 验证器命名空间
            const scope = 'add';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    if(this.images.length && this.images[0].url){
                        this.current.storePhoto=this.images[0].url;
                    }else {
                        this.current.storePhoto="";
                    }
                    return _this.current;
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                    // this.$message.error(error)
                }
            }).then(formData => {
                console.log('formData', formData);
                if (formData) {
                    addStore(formData).then(function (success) {
                        _this.$message.success("添加成功");
                        _this.modalName=null;
                        _this.initData();
                    }).catch(function (error) {
                        console.log(error)
                    })
                }
            })
        },
        //取消添加
        addClose: function () {
            this.modalName = null;
        },
        //    编辑确定
        editSubmit: function () {
            var _this = this;
            // 验证器命名空间
            const scope = 'edit';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    if(this.images.length && this.images[0].url){
                        this.current.storePhoto=this.images[0].url;
                    }else {
                        this.current.storePhoto="";
                    }
                    return this.current;
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                }
            }).then(formData => {
                console.log("编辑后待提交:");
                console.log(formData);
                if (formData) {
                    editStore(formData).then(function (success) {
                        _this.$message.success("修改成功");
                        _this.modalName=null;
                        _this.initData();
                    }).catch(function (error) {
                        console.log(error)
                    })
                }
            })
        },
        //    禁用确定
        disabledSubmit: function () {
            var _this = this;
            var obj = {
                status: 1,
                storeId: this.current.storeId
            }
            console.log(obj);
            updateStatus(obj).then(function (success) {
                _this.$message.success("禁用成功");
                _this.modalName=null;
                _this.initData();
            }).catch(function (error) {

            })
        },
        //    启用确定
        activeSubmit: function () {
            var _this = this;
            var obj = {
                status: 0,
                storeId: this.current.storeId
            }
            console.log(obj);
            updateStatus(obj).then(function (success) {
                _this.$message.success("启用成功");
                _this.modalName=null;
                _this.initData();
            }).catch(function (error) {

            });
        },
        //    删除确定
        deleteSubmit: function () {
            var _this = this;
            var obj = {
                storeId: this.current.storeId
            }
            deleteStore(obj).then(function (success) {
                _this.$message.success("删除成功");
                _this.modalName=null;
                _this.initData();
            }).catch(function (error) {

            })
        },

        layer(options) {
            layer.open({
                type: 2,
                title: false,
                closeBtn: 0,
                shadeClose: true,
                area: ["672px", "379px"],
                ...options
            });
        }
    },
    async mounted() {
        // 加载JS
        await myLayerImport();
    },
    created() {
        var _this = this;
        console.log(this.mix_query)
        //    全局方法，暴露address对象
        window.initAddress = function (params) {
            console.log(params)
            _this.current.province = params.province;
            _this.current.city = params.city;
            _this.current.area = params.area;
            _this.current.storeAdd = params.storeAdd;
            _this.current.longitude = params.longitude;
            _this.current.latitude = params.latitude;
        }

    }
}
</script>

<style lang="scss" >
   /* .layui-layer-iframe{
        z-index: 1 !important;
    }*/
    .page-store{
        .store {
            .xc-form-item-label {
                width: 100px !important;
            }
            .xc-select-area {
                width: 113px;
                margin-right: 17px;
            }
            .address {
                .xc-form-item-content {
                    display: flex;
                }
            }
            .location {
                .xc-form-item-content {
                    position: relative;
                    .storeAdd {
                        width: 373px !important;
                    }
                    .locationIcon {
                        position: absolute;
                        right: 3px;
                        top: 3px;
                        display: block;
                        width: 36px;
                        height: 26px;
                    }
                }
            }
            .department {
                position: relative;
                .myDepartment {
                    position: absolute;
                    top: 0;
                    right: 0;
                    border-radius: 0 5px 5px 0;
                    cursor: pointer;
                    box-shadow: -1px 0 2px 0 #bbb;
                    width: 32px;
                    line-height: 32px;
                    text-align: center;
                }
            }
        }
    }

</style>
